import React, { memo } from 'react';
import { KContainer, KLabel } from 'uikit';

interface Props {
  isActive: boolean;
}

const CategoriesForm = ({ isActive }: Props) => {
  if (!isActive) {
    return null;
  }

  return (
    <KContainer.View>
      <KLabel.Text>CategoriesForm</KLabel.Text>
    </KContainer.View>
  );
};

export default memo(CategoriesForm);
